import React from 'react';
import Modal from '@material-ui/core/Modal';
import { makeStyles } from '@material-ui/core/styles';
import BasicButton from '../BasicButton/BasicButton';
import '../shared.scss';
import './WarningNotesModal.scss';

const useStyles = makeStyles(() => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px 16px',
    },
    paper: {
        backgroundColor: '#fff',
        border: '2px solid grey',
        borderRadius: '8px',
        boxShadow: '0 8px 24px rgba(0, 0, 0, 0.18)',
    },
}));

export default function WarningNotesModal(props) {
    const classes = useStyles();
    const {
        open = false,
        title = 'Warning',
        warningLines = [],
        onConfirm,
        handleClose,
    } = props;

    const lines = Array.isArray(warningLines) ? warningLines.filter(Boolean) : [];

    return (
        <div className="BasicModalContainer">
            <Modal
                open={open}
                onClose={handleClose}
                className={classes.modal}
            >
                <div className={`${classes.paper} warning-notes-modal-paper`}>
                    <div className="MessageTitle">
                        <label>{title}</label>
                    </div>
                    <div className="warning-notes-modal-body">
                        <div className="warning-notes-modal-notes">
                                {lines.map((line, index) => (
                                    <div key={`warning-line-${index}`} className="warning-notes-modal-line">
                                    The {line.entityLabel} &quot;
                                    <strong className="warning-notes-modal-bold">{line.entityName}</strong>
                                    &quot; has warning notes &quot;
                                    <strong className="warning-notes-modal-bold">{line.warningNotes}</strong>
                                    &quot;
                                    </div>
                                ))}
                        </div>

                        <div className="warning-notes-modal-actions">
                            <BasicButton
                                variant="contained"
                                text="OK"
                                type="inline"
                                onClick={onConfirm || handleClose}
                            />
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    );
}
